// Wait 100ms before removing the waves effect from DOM elements, in order to make sure they have been initialized.
export const removeWavesEffectFromAllElements = () => (setTimeout(
    () => jQuery('.waves-effect').removeClass('waves-effect waves-light'),
    100
));

/**
 * Trigger click event on any focused element if enter is pressed.
 * @returns {*|jQuery}
 */
export const enableClickFocusedElementOnEnter = () => jQuery('html').keypress(e => {
    const focusedElement = $(':focus');
    if (focusedElement.attr('id') === 'increase-font-size') {
        return;
    }
    e.keyCode === 13 && focusedElement.trigger('click');
});

/**
 * Remove borders from focused elements (caused by tabindex).
 */
export const removeBorderFromFocusedElements = () => {
    const tabIndexSelector = '[tabindex]';
    $(tabIndexSelector).focus(function () {
        $(this).css('outline', 'none');
    });
    $(tabIndexSelector).keyup(function (event) {
        if (event.keyCode === 9) {
            $(this).css('outline', '');
        }
    });
}
